const useQuery = (query: string): string => new URLSearchParams(window.location.search).get(query);

export default useQuery;
